module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABK0lEQVQ4jYXTuy5EURQG4G/OTFxDoZBIhIiGhkQpaMjoJDqXwvU9RMITDNGJhoIa8QAkCo1SJESi07tlUMw+yTFzzszfnLXX+v9122fnNl/31MEGyjjKIhTqqdHRIC7K8BXRjla0BLuIXKMEnbjAFVYxiAGsBd8l2pKC5AhNOMdEOI9hPBRpDr7ZkGQG39Ud7CbEsI59HGAl4Z/CTnzIhVsYxR3yCeIvukKRN//nL4cO7+MOtqvEgqAffWqXl8dWPEI/5qSjZusJzKO3gIU6xHfpVx0nXyyobDQN33gKxLLaEWE6wkhGglt84TPYaRiJ0J0RPE7YJxmcngg/KYFn/x/QIV5SeOUIj1XODyyHb4x3LKmMk8RDhFIInGISw7hJqXaNIZU/8UxlyaU/LOM1ToHGC8kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthIcon/huxi-2.png
// module id = mZsj
// module chunks = 4